import type { HttpClient, HttpResponse } from '@/utils/HttpClient';
import type { Assortment, AssortmentFetchError } from '@/types/products';

export type AssortmentService = {
  fetchAssortment: (customerId: string) => Promise<HttpResponse<Assortment, AssortmentFetchError>>;
};

export const AssortmentService = (httpClient: HttpClient): AssortmentService => ({
  fetchAssortment(customerId) {
    return httpClient({ endpoint: `/customers/${customerId}/assortment` });
  },
});
